import { useNavigate } from '@reach/router';
import instance from 'api';
import Button from 'components/button/Button';
import { endpoints } from 'endpoints.config';
import { Toast } from 'helpers/toast';
import { useDispatch } from 'react-redux';
import { getCustomerComponentResources } from 'reducers/componentResources';
import { CardSubPage } from './CardPage';
import FormTextField from 'components/form/FormTextField';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useState } from 'react';
import {Modal} from 'components/modal/Modal';

const initialValues = {
    pin: '',
};

const validationSchema = Yup.object({
    pin: Yup.string().required('Please enter a PIN').length(4, 'PIN must be 4 digits long'),
});

    export const ActivateCard = ({ cardId }: { cardId: number }) => {
        const dispatch = useDispatch();
        const navigate = useNavigate();
        const [showStatusModal, setShowStatusModal] = useState(false);
        const [statusMessage, setStatusMessage] = useState('');

        const activate = ({ pin }: { pin: string }, formikHelpers: any) => {
        instance
            .post(endpoints.cards.activateCard, { topUpCardsId: cardId, pin })
            .then((res) => {
                Toast.openSuccessToast('Your card has been activated successfully');
                dispatch(getCustomerComponentResources());
                navigate(`../${cardId}/${CardSubPage.TRANSACTIONS}`);
            })
            .catch((err) => {
                const errorCode = err?.response?.data?.errors?.[0]?.messageCode;
                const fieldName = err?.response?.data?.errors?.[0]?.fieldName;

                if (fieldName === 'CardStatus') {
                    if (errorCode === 'Card_Processing_In_Progress') {
                        setStatusMessage('Your card is currently being processed. Please wait a few moments and try again.');
                        setShowStatusModal(true);
                    } else if (errorCode === 'Card_Not_Ready_For_Activation') {
                        setStatusMessage('Your card is not ready for activation yet. Please contact support if this issue persists.');
                        setShowStatusModal(true);
                    } else {
                        Toast.openGenericErrorToast();
                    }
                } else {
                    Toast.openGenericErrorToast();
                }
            })
            .finally(() => {
                formikHelpers.setSubmitting(false);
            });
    };

    return (
        <div className="ActivateCardPage FormPage">
            <div className="ActivationInstructions">
                <p className="ActivationInstructions__lead">To complete your activation:</p>
                <ol className="ActivationInstructions__steps">
                    <li>
                        <span className="StepNumber">1</span>
                        <span className="StepText">Set your 4-digit PIN</span>
                    </li>
                    <li>
                        <span className="StepNumber">2</span>
                        <span className="StepText">Click &ldquo;Activate Card&rdquo;</span>
                    </li>
                </ol>
            </div>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={activate}
            >
                {(props) => (
                    <Form>
                        <FormTextField
                            field="pin"
                            required
                            label="PIN"
                            placeholder="4 digit pin"
                            inputMode="numeric"
                            type="password"
                            maxLength={4}
                            onChange={(e) => {
                                props.setFieldValue('pin', e.target.value.replaceAll(/\D/g, ''));
                            }}
                        />
                        <Button variety="full" type="submit" disabled={props.isSubmitting}>
                            Activate Card
                        </Button>
                    </Form>
                )}
            </Formik>

           {showStatusModal && (
                <Modal onCloseModal={() => setShowStatusModal(false)}>
                    <div className="modal-content">
                        <h3>Card Activation Status</h3>
                        <p>{statusMessage}</p>
                        <Button variety="full" onClick={() => setShowStatusModal(false)}>OK</Button>
                    </div>
                </Modal>
            )}
        </div>
    );
};